import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';

class SeatsioService {
    chart;
    async showDesigner(config) {
        const seatsioInstance = await this.getSeatsio(config.region, config.chartJsUrl);
        delete config['chartJsUrl'];
        delete config['region'];
        return new seatsioInstance.SeatingChartDesigner(config).render();
    }
    async showSeatingChart(config) {
        const seatsioInstance = await this.getSeatsio(config.region, config.chartJsUrl);
        delete config['chartJsUrl'];
        delete config['region'];
        return new seatsioInstance.SeatingChart(config).render();
    }
    async showEventManager(config) {
        const seatsioInstance = await this.getSeatsio(config.region, config.chartJsUrl);
        delete config['chartJsUrl'];
        delete config['region'];
        return new seatsioInstance.EventManager(config).render();
    }
    getSeatsio(region, chartJsUrl) {
        if (typeof seatsio !== 'undefined') {
            return Promise.resolve(seatsio);
        }
        return this.loadSeatsio(region, chartJsUrl);
    }
    loadSeatsio(region, chartJsUrl = 'https://cdn-{region}.seatsio.net/chart.js') {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.onload = () => resolve(seatsio);
            script.onerror = () => reject(`Could not load ${script.src}`);
            script.src = chartJsUrl.replace('{region}', region);
            document.head.appendChild(script);
        });
    }
    ngOnDestroy() {
    }
    ngOnInit() {
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    /** @nocollapse */ static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class SeatsioComponent {
    elRef;
    config;
    seatsioService;
    chart;
    constructor(seatsioService, elRef) {
        this.elRef = elRef;
        this.seatsioService = seatsioService;
    }
    render(config) {
        throw new Error('Not implemented');
    }
    async ngOnInit() {
        this.config['divId'] = undefined;
        this.config['container'] = this.elRef.nativeElement.firstElementChild;
        this.chart = await this.render(this.config);
        if ('onRenderStarted' in this.config) {
            this.config['onRenderStarted'](this.chart);
        }
    }
    ngOnDestroy() {
        if (this.chart) {
            this.chart.destroy();
        }
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioComponent, deps: [{ token: SeatsioService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.0", type: SeatsioComponent, selector: "ng-component", inputs: { config: "config" }, ngImport: i0, template: '', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioComponent, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], ctorParameters: function () { return [{ type: SeatsioService }, { type: i0.ElementRef }]; }, propDecorators: { config: [{
                type: Input
            }] } });

class SeatsioDesignerComponent extends SeatsioComponent {
    constructor(seatsioService, elRef) {
        super(seatsioService, elRef);
    }
    render(config) {
        return this.seatsioService.showDesigner(config);
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioDesignerComponent, deps: [{ token: SeatsioService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.0", type: SeatsioDesignerComponent, selector: "si-seatsio-designer", providers: [SeatsioService], usesInheritance: true, ngImport: i0, template: "<div style=\"height: 100%; width: 100%;\"></div>\n" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioDesignerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-seatsio-designer', providers: [SeatsioService], template: "<div style=\"height: 100%; width: 100%;\"></div>\n" }]
        }], ctorParameters: function () { return [{ type: SeatsioService }, { type: i0.ElementRef }]; } });

class SeatsioSeatingChartComponent extends SeatsioComponent {
    constructor(seatsioService, elRef) {
        super(seatsioService, elRef);
    }
    render(config) {
        return this.seatsioService.showSeatingChart(config);
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioSeatingChartComponent, deps: [{ token: SeatsioService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.0", type: SeatsioSeatingChartComponent, selector: "si-seatsio-seating-chart", providers: [SeatsioService], usesInheritance: true, ngImport: i0, template: "<div style=\"height: 100%; width: 100%;\"></div>\n" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioSeatingChartComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-seatsio-seating-chart', providers: [SeatsioService], template: "<div style=\"height: 100%; width: 100%;\"></div>\n" }]
        }], ctorParameters: function () { return [{ type: SeatsioService }, { type: i0.ElementRef }]; } });

class SeatsioEventManagerComponent extends SeatsioComponent {
    constructor(seatsioService, elRef) {
        super(seatsioService, elRef);
    }
    render(config) {
        return this.seatsioService.showEventManager(config);
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioEventManagerComponent, deps: [{ token: SeatsioService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.0", type: SeatsioEventManagerComponent, selector: "si-seatsio-event-manager", providers: [SeatsioService], usesInheritance: true, ngImport: i0, template: "<div style=\"height: 100%; width: 100%;\"></div>\n" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioEventManagerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-seatsio-event-manager', providers: [SeatsioService], template: "<div style=\"height: 100%; width: 100%;\"></div>\n" }]
        }], ctorParameters: function () { return [{ type: SeatsioService }, { type: i0.ElementRef }]; } });

class SeatsioAngularModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioAngularModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.0", ngImport: i0, type: SeatsioAngularModule, declarations: [SeatsioComponent,
            SeatsioDesignerComponent,
            SeatsioSeatingChartComponent,
            SeatsioEventManagerComponent], exports: [SeatsioDesignerComponent,
            SeatsioSeatingChartComponent,
            SeatsioEventManagerComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioAngularModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.0", ngImport: i0, type: SeatsioAngularModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SeatsioComponent,
                        SeatsioDesignerComponent,
                        SeatsioSeatingChartComponent,
                        SeatsioEventManagerComponent
                    ],
                    imports: [],
                    exports: [
                        SeatsioDesignerComponent,
                        SeatsioSeatingChartComponent,
                        SeatsioEventManagerComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of seatsio-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SeatsioAngularModule, SeatsioDesignerComponent, SeatsioEventManagerComponent, SeatsioSeatingChartComponent, SeatsioService };
